// NewSidebar/iconMap.js
import React from "react";
import Dashboard from "../Icon/Dashboard";
import OrderIcon from "../Icon/OrderIcon";
import CustomerIcon from "../Icon/CustomerIcon";
import PlateQcIcon from "../Icon/PlateQcIcon";
import Production from "../Icon/Production";
import ReportIcon from "../Icon/ReportsIcon";
import MaterialIcon from "../Icon/MaterialIcon";
import SideBardStoreIocn from "../Icon/SideBardStoreIocn";
import BasicInformation from "../Icon/BasicInformation";
import PersonFormIcon from "../Icon/PersonFormIcon";
import ContactIcon from "../Icon/ContactIcon";
import TicketIcon from "../Icon/TicketIcon";
import SchedulerIcon from "../Icon/schedulerIcon";
import PrintAssistant from "../Icon/PrintAssistant";
import LogOutIcon from "../Icon/LogOutIcon";
import CustomerOrdersArchivedIcon from "../Icon/CustomerOrdersArchivedIcon";
import OrderPaymentIcon from "../Icon/OrderPaymentIcon";
import OclockOrderPaymentIcon from "../Icon/OclockOrderPaymentIcon";
import DesignerIcon from "../Icon/DesignerIcon";

/**
 * مپ نام آیکون (string) به کامپوننت React
 * کلیدها دقیقاً مطابق مقدار "icon" در sidebarMenu.json هستند
 */
const iconMap = {
  Dashboard: <Dashboard />,
  OrderIcon: <OrderIcon />,
  CustomerIcon: <CustomerIcon />,
  PlateQcIcon: <PlateQcIcon />,
  Production: <Production />,
  ReportIcon: <ReportIcon />,
  MaterialIcon: <MaterialIcon />,
  SideBardStoreIocn: <SideBardStoreIocn />,
  BasicInformation: <BasicInformation />,
  PersonFormIcon: <PersonFormIcon />,
  ContactIcon: <ContactIcon />,
  TicketIcon: <TicketIcon />,
  SchedulerIcon: <SchedulerIcon />,
  PrintAssistant: <PrintAssistant />,
  LogOutIcon: <LogOutIcon />,
  CustomerOrdersArchivedIcon: <CustomerOrdersArchivedIcon />,
  OrderPaymentIcon: <OrderPaymentIcon />,
  OclockOrderPaymentIcon: <OclockOrderPaymentIcon />,
  DesignerIcon : <DesignerIcon/>,
  // آیکون خاص «کنترل و نظارت» که از فونت‌آیکون استفاده می‌کند
  ControlIcon: (
    <i
      style={{ color: "white" }}
      className="icon-Password-Minimalistic-Input"
    />
  ),
};

export default iconMap;
